import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment';
const paysList = require('../../../../assets/jsons/countries.json');
import { models } from '../modele/modele-form';
import { ActivatedRoute } from '@angular/router';
import { UtilsService } from 'src/app/services/utils.service';
import { SubscriptionService } from 'src/app/services/subscription.service';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
  selector: 'app-mrp',
  templateUrl: './mrp.component.html',
  styleUrls: ['./mrp.component.scss']
})
export class MrpComponent implements OnInit {

  // Navigation et état
  currentStep = 0;
  totalSteps = 5; // accueil + 3 étapes + récapitulatif
  
  // Formulaire principal
  simulationMrpForm: FormGroup;
  
  // États de l'interface
  loader: boolean = false;
  sendingRequest: boolean = false;
  isFocus: boolean = false;
  hasPhoneError: boolean = false;
  
  // Données
  listPays = paysList;
  listQualiteProposant = [
    {name:'Locataire', value:'Locataire'}, 
    {name:'Propriétaire', value:'Propriétaire'}
  ];
  listTypesConstruction = [
    {name:'Dur', value:'Dur'}, 
    {name:'Conteneur', value:'Conteneur'}, 
    {name:'Vitré', value:'Vitré'}
  ];
  listOuiNon = [
    {name:'Oui', value:'oui'}, 
    {name:'Non', value:'non'}
  ];
  
  // Configuration
  newDate = new Date();
  emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  
  // Références
  numeroSous: string;
  refPro: string;
  
  // Informations de la page
  slideData;
  lien = "";
  informations;
  title = "";

  // Document technique
  nomFile: string = "";
  noImage: string = "assets/images/upload.png";
  pieceJointe: FormGroup;
  downloadIcon = "assets/fileDownload/file.png";
  downloadFile: boolean = true;
  typeProduitList: any = {
    questionnaireUrl: '/assets/fileDownload/questionnaire_mrp.pdf'
  };

  currentFiliale = JSON.parse(localStorage.getItem('currentFiliale'));

  // ===== AJOUT POUR AUTOSAVE =====
  private autoSaveSubject$ = new Subject<any>();
  private autoSaveSubscription: Subscription;
  private lastSavedData: string = ''; // Pour comparer les données
  // ================================

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private utilsService: UtilsService,
    private rechercheService: SubscriptionService
  ) {
    // Initialisation des références
    let time = new Date().getTime();
    let pro = new Date().getTime() + 123890989;
    this.numeroSous = "SN" + time + "MRP";
    this.refPro = "SN" + pro + "PR";

    // @ts-ignore
    let lienBrute: String = this.route.snapshot._routerState.url;
    this.lien = lienBrute.substring(1, lienBrute.length);
    this.informations = models[this.lien];
        
    localStorage.setItem('sectionShown', this.lien);
    this.slideData = [{
      title: "Inclusive Market",
      subTitle: "Toutes vos assurances en 1 seul endroit",
      description: "Votre devis gratuit personnalisé en quelques clics",
      img: "assets/images/slide-mrp.png",
      type: "ASSURANCE MULTIRISQUE PRO",
      imgIcon: "assets/images/foreman-green.svg"
    }]; 
  }

  ngOnInit() {
    this.initializeForm();
    this.setupAutoSave();
  }

  // Initialisation du formulaire
  initializeForm() {
    this.simulationMrpForm = this.fb.group({
      // Informations sur l'entreprise
      nomEntreprise: ['', Validators.required],
      adresse: ['', Validators.required],
      // email: ['', [Validators.required, Validators.pattern(this.emailPattern)]],
      email: new FormControl('', [Validators.compose([Validators.required, Validators.pattern(this.emailPattern)])]),
      telephone: ['', Validators.required],
      qualiteProposant: ['', Validators.required],
      services: ['', Validators.required],
      valeurBatiment: ['', Validators.required],
      loyer: [''],
      
      // Choix des garanties
      typesConstruction: ['', Validators.required],
      moyenProtection: ['', Validators.required],
      dispositifInformatique: ['', Validators.required],
      vitreGlaces: ['', Validators.required]
    });

    // FormGroup séparé pour le document technique
    this.pieceJointe = new FormGroup({
      file: new FormControl('')
    });
  }

  // Navigation entre les étapes
  nextStep() {
    if (this.currentStep === 0) {
      // Depuis la page d'accueil, on va aux informations entreprise
      this.currentStep = 1;
      setTimeout(() => window.scrollTo({ top: 500, behavior: 'smooth' }), 100);
      return;
    }
    
    if (this.isCurrentStepValid()) {
      if (this.currentStep < 4) {
        this.currentStep++;
        setTimeout(() => window.scrollTo({ top: 500, behavior: 'smooth' }), 100);
      }
    } else {
      this.markFormGroupTouched();
      this.toastr.warning("Veuillez remplir tous les champs obligatoires", "Attention");
    }
  }

  previousStep() {
    if (this.currentStep > 0) {
      this.currentStep--;
      window.scrollTo(0, 0);
    }
  }

  // Validation des étapes
  isCurrentStepValid(): boolean {
    switch (this.currentStep) {
      case 0: // Page d'accueil
        return true;
        
      case 1: // Informations sur l'entreprise
        return this.simulationMrpForm.get('nomEntreprise')?.valid && 
               this.simulationMrpForm.get('adresse')?.valid &&
               this.simulationMrpForm.get('email')?.valid &&
               this.simulationMrpForm.get('telephone')?.valid &&
               this.simulationMrpForm.get('qualiteProposant')?.valid &&
               this.simulationMrpForm.get('services')?.valid &&
               this.simulationMrpForm.get('valeurBatiment')?.valid &&
               this.isLoyerValid();
      
      case 2: // Choix des garanties
        return this.simulationMrpForm.get('typesConstruction')?.valid &&
               this.simulationMrpForm.get('moyenProtection')?.valid &&
               this.simulationMrpForm.get('dispositifInformatique')?.valid &&
               this.simulationMrpForm.get('vitreGlaces')?.valid;
      
      default:
        return true;
    }
  }

  // Validation conditionnelle du loyer
  isLoyerValid(): boolean {
    const qualiteProposant = this.simulationMrpForm.get('qualiteProposant')?.value;
    const loyer = this.simulationMrpForm.get('loyer')?.value;
    
    if (qualiteProposant === 'Locataire') {
      return loyer && loyer.length > 0;
    }
    return true;
  }

  // Gestion du changement de qualité proposant
  onQualiteProposantChange() {
    const qualiteProposant = this.simulationMrpForm.get('qualiteProposant')?.value;
    const loyerControl = this.simulationMrpForm.get('loyer');
    
    if (qualiteProposant === 'Locataire') {
      loyerControl?.setValidators([Validators.required]);
    } else {
      loyerControl?.clearValidators();
      loyerControl?.setValue('');
    }
    loyerControl?.updateValueAndValidity();
  }

  markFormGroupTouched() {
    Object.keys(this.simulationMrpForm.controls).forEach(key => {
      const control = this.simulationMrpForm.get(key);
      if (control) {
        control.markAsTouched();
      }
    });
  }

  // Gestion du téléphone
  hasError(event: any, field: string, form: string) {
    this.hasPhoneError = !event;
  }

  getNumber(number: string, field: string, form: string) {
    this.simulationMrpForm.get(field)?.setValue(number);
  }

  telInputObject(obj: any) {
    // Gestion de l'objet téléphone
  }

  onCountryChange(country: any) {
    // Gestion du changement de pays pour le téléphone
  }

  // Gestion des fichiers
  selectOnFile(evt: any, type?: string, name?: string) {
    this.nomFile = name || 'Fichier sélectionné';
    this.loader = true;
    
    const accept = ['.doc', '.DOC', '.docx', '.DOCX', '.docm', '.DOCM', '.pdf', '.PDF', 
                   '.xls', '.XLS', '.xlsx', '.XLSX', '.png', '.PNG', '.jpg', '.JPG', '.jpeg', '.JPEG'];
    
    for (const file of evt.target.files) {  
      const index = file.name.lastIndexOf(".");
      const strsubstring = file.name.substring(index, file.name.length);
      let ext = strsubstring;
      
      if (accept.indexOf(strsubstring) === -1) {
        this.loader = false;
        this.toastr.error(`Ce fichier ${file.name} n'est pas au format autorisé`, 'Erreur');
        evt.target.value = '';
        return;
      } else {
        this.loader = true;
        const reader = new FileReader();
        
        reader.onload = (e: any) => {
          const docBase64Path = e.target.result;
          let image = '';
          
          if (ext === '.doc' || ext === '.DOC' || ext === '.docx' || ext === '.DOCX' || ext === '.docm' || ext === '.DOCM') {
            image = 'assets/images/doc.png';
            this.noImage = 'assets/images/doc.png';
          }
          else if (ext === '.pdf' || ext === '.PDF') {
            image = 'assets/images/pdf.png';
            this.noImage = 'assets/images/pdf.png';
          }
          else if (ext === '.xlsx' || ext === '.XLSX' || ext === '.xls' || ext === '.XLS') {
            image = 'assets/images/excel.png';
            this.noImage = 'assets/images/excel.png';
          }
          else {
            image = docBase64Path;
            this.noImage = docBase64Path;
          }
          this.saveFile1(file);
        };
        reader.readAsDataURL(file);
      }
    }
  }

  saveFile1(file: File) {
    this.loader = true;
    let dataFile = new FormData();
    dataFile.append('files', file);
    
    this.rechercheService.saveFile(dataFile).subscribe(
      resp => {
        if (resp) {
          this.loader = false;
          this.toastr.success("Fichier chargé avec succès", 'Succès');
          this.pieceJointe.get('file')?.setValue(resp['urlprod']);
        }
      }, 
      error => {
        this.loader = false;
        this.noImage = "assets/images/upload.png";
        this.nomFile = "";
        const errorMessage = error?.error?.errors?.[0]?.message || 
                            error?.error?.message || 
                            "Erreur lors du chargement du fichier";
        
        this.toastr.error(errorMessage, 'Erreur');
        this.pieceJointe.get('file')?.setValue('');
      }
    );
  }

  downloadModel() {
    if (this.typeProduitList?.questionnaireUrl) {
      window.open(this.typeProduitList.questionnaireUrl, '_blank');
    } else {
      window.open('/assets/fileDownload/questionnaire_mrp.pdf', '_blank');
    }
    this.downloadFile = false;
  }

  // Sauvegarde
  saveData() {
    this.sendingRequest = true;
    this.loader = true;
    
    const finalData = {
      ...this.simulationMrpForm.value,
      pieceJointe: this.pieceJointe.value,
      numeroSous: this.numeroSous,
      refPro: this.refPro
    };

    const submissionData = {
      designationClient: finalData.nomEntreprise,
      telephone: finalData.telephone,
      email: finalData.email,
      typeRisque: "MRP",
      content: JSON.stringify(finalData)
    };
    
    this.rechercheService.saveSouscriptionOffline(submissionData)
      .subscribe(response => {
        if (response['responseCode'] == 200) {
          this.sendingRequest = false;
          this.loader = false;
          this.toastr.success("Demande de souscription enregistrée avec succès");
          this.currentStep = 4; // Étape succès
        } else {
          this.sendingRequest = false;
          this.loader = false;
          this.toastr.error(response['cause'].erreurs[0].message);
        }
      }, errors => {
        this.sendingRequest = false;
        this.loader = false;
        const errorMessage = errors['error']['cause'].erreurs ? 
          errors['error']['cause'].erreurs[0].message : 
          errors['error']['cause']['message'];
        this.toastr.error(errorMessage);
      });
  }

  resetForm() {
    this.currentStep = 0;
    this.simulationMrpForm.reset();
    this.pieceJointe.reset();
    this.nomFile = "";
    this.noImage = "assets/images/upload.png";
    window.scrollTo(0, 0);
  }

  getProgressPercentage(): number {
    const progressSteps = {
      0: 0,   // Page d'accueil
      1: 33,  // Informations entreprise
      2: 66,  // Choix des garanties
      3: 100, // Récapitulatif
      4: 100  // Succès
    };
    
    return progressSteps[this.currentStep] || 0;
  }

  getProgressText(): string {
    const progressTexts = {
      0: 'Bienvenue...',
      1: 'Informations entreprise...',
      2: 'Choix des garanties...',
      3: 'Finalisation...',
      4: 'Terminé!'
    };
    
    return progressTexts[this.currentStep] || 'Chargement en cours...';
  }

  // Méthode utilitaire pour formater les montants
  formatMontant(value: string): string {
    if (!value) return '';
    return new Intl.NumberFormat('fr-FR').format(parseInt(value.replace(/\s/g, '')));
  }

  // Méthode pour gérer la saisie des montants
  onMontantInput(event: any, field: string) {
    let value = event.target.value.replace(/\s/g, '');
    if (value && !isNaN(value)) {
      const formattedValue = this.formatMontant(value);
      this.simulationMrpForm.get(field)?.setValue(formattedValue);
    }
  }


  //   autoSave() { 
  //   const finalData = {
  //     ...this.simulationMrpForm.value
  //   };
    
  //   let data = {
  //           "telephone": finalData.telephone,
  //           "email": finalData.email,
  //           "adresse": finalData.adresse,
  //           "type": "ASSURANCE MULTIRISQUE PRO",
  //           "displayName": finalData.nomEntreprise,
  //           "filiale": this.currentFiliale?.id,
  //   };  
  //   this.rechercheService.autoSave(data)
  //     .subscribe(response => {
        
  //     }, errors => {
  //     });
  // }


  // ===== CONFIGURATION DE L'AUTOSAVE =====
  private setupAutoSave() {
    this.autoSaveSubscription = this.autoSaveSubject$.pipe(
      debounceTime(1000),
      distinctUntilChanged((prev, curr) => {
        return prev.email === curr.email && prev.telephone === curr.telephone;
      }),
      switchMap(data => {
        const currentDataString = JSON.stringify({
          email: data.email,
          telephone: data.telephone
        });
        
        if (currentDataString === this.lastSavedData) {
          return of(null);
        }
        
        this.lastSavedData = currentDataString;
        
        return this.rechercheService.autoSave(data).pipe(
          catchError(error => {
            return of(null);
          })
        );
      })
    ).subscribe(response => {
    });
  }

  // ===== MÉTHODE AUTOSAVE AMÉLIORÉE =====
  autoSave() {
    const formValue = this.simulationMrpForm?.value;
    if (!formValue) return;

    const hasValidEmail = formValue.email && this.emailPattern.test(formValue.email);
    
    const hasValidPhone = formValue.telephone && formValue.telephone.trim().length >= 8;

    if (!hasValidEmail && !hasValidPhone) {
      return;
    }

    if (!this.currentFiliale?.id) {
      return;
    }

    let data = {
            "telephone": formValue.telephone?.trim(),
            "email": formValue.email?.trim().toLowerCase(),
            "adresse": formValue.adresse,
            "type": "ASSURANCE MULTIRISQUE PRO",
            "displayName": formValue.nomEntreprise,
            "filiale": this.currentFiliale?.id,
    };  

    this.autoSaveSubject$.next(data);
  }
  // ========================================


  getDevisAutre() {
        this.currentStep = 0;
        setTimeout(() => {
            window.scrollTo({
                top: 600,
                behavior: 'smooth'
            });
        }, 100);
  }

}